import AdvertismentWFFMDataExchange from '@/services/AdvertismentWFFMDataExchange'

/**
 * A mixin adding destination editing logic and data
 */
export default {
  data () {
    return {
      dx: { advertisment: new AdvertismentWFFMDataExchange(this.form) },
      advertisment: '',
    }
  },
  created () {
    this.advertisment = this.dx.advertisment.data
  },
}



// WEBPACK FOOTER //
// ./src/components/search/logic/Advertisment.js